import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { Button } from "@app/components";
import { useDispatch, useSelector } from 'react-redux';
import { setStep } from '@app/store/reducers/enrollmentForm';

const EnrollmentStep3 = (props) => {
        
    const enrollmentStore = useSelector((state: any) => state.enrollmentForm);
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    useEffect(() => {
    
        return () => {

        }
    },[]);
    

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue } = useFormik({
        initialValues: {
            step: 3,
            emergency_contact_name: enrollmentStore?.formData?.emergency_contact_name || '',
            emergency_contact_relation: enrollmentStore?.formData?.emergency_contact_relation || '',
            emergency_contact_phone: enrollmentStore?.formData?.emergency_contact_phone || '',
            allergies: enrollmentStore?.formData?.allergies || '',
            medical_conditions: enrollmentStore?.formData?.medical_conditions || '',
            medication: enrollmentStore?.formData?.medication || '',
        },
        validationSchema: Yup.object({
            emergency_contact_name: Yup.string().trim().required('Please enter full name').max(100, 'Full name must be 100 characters or less'),
            emergency_contact_relation: Yup.string().trim().required('Please enter relationship to student').max(100, 'Relation must be 50 characters or less'),
            emergency_contact_phone: Yup.string().required('Please enter contact number')
                .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                    "Please enter valid number"
                ),
            allergies: Yup.string().max(100, 'Allergies must be 100 characters or less'),
            medication: Yup.string().max(100, 'Medication must be 100 characters or less'),
            medical_conditions: Yup.string().max(100, 'Medical conditions or special learning must be 100 characters or less')
        }),
        onSubmit: (values) => {
            props?.updateEnrollmentDetailsAPI(values)
        },
        enableReinitialize: true,
    });

    return (
        <>
        <Form onSubmit={handleSubmit}>
        <div className="content mb-3">
            <h6 className="mb-4 grey_wrapper_title"><i className="fas fa-exclamation-triangle"/> &nbsp; Emergency Contact Information </h6>
            <div className="content_inner_wrap">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="emergency_contact_name"> Full Name of Emergency Contact <span className="required">*</span></label>
                            <input type="text" className="form-control" id="emergency_contact_name" placeholder="Enter full name" 
                                name="emergency_contact_name" 
                                onChange={handleChange} 
                                value={values.emergency_contact_name}
                            />
                            {(touched.emergency_contact_name && errors.emergency_contact_name) && (
                                <div className="text-danger">
                                    {errors.emergency_contact_name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="emergency_contact_relation">Relationship to Student <span className="required">*</span></label>
                            <input type="text" className="form-control" id="emergency_contact_relation" placeholder="Enter relationship to student" 
                                name="emergency_contact_relation" 
                                onChange={handleChange} 
                                value={values.emergency_contact_relation}
                            />
                            {(touched.emergency_contact_relation && errors.emergency_contact_relation) && (
                                <div className="text-danger">
                                    {errors.emergency_contact_relation}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="emergency_contact_phone">Contact Number <span className="required">*</span></label>
                            <Form.Control 
                                type="text" 
                                className="form-control" 
                                id="emergency_contact_phone" 
                                placeholder="Enter contact number"
                                name="emergency_contact_phone" 
                                onChange={handleChange} 
                                value={values.emergency_contact_phone}
                            />
                            {(touched.emergency_contact_phone && errors.emergency_contact_phone) && (
                                <div className="text-danger">
                                    {errors.emergency_contact_phone}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="content mb-3">
            <h6 className="mb-4 grey_wrapper_title"><i className="fas fa-first-aid" /> &nbsp; Medical Information </h6>
            <div className="content_inner_wrap">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Any Allergies</label>
                            <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter allergies" 
                                name="allergies" 
                                onChange={handleChange} 
                                value={values.allergies}
                            />
                            {(touched.allergies && errors.allergies) && (
                                <div className="text-danger">
                                    {errors.allergies}
                                </div>
                            )}
                        </div>
                    </div>
                     <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="medication">Medication (if any)</label>
                            <Form.Control 
                                type="text" 
                                className="form-control" 
                                id="medication" 
                                placeholder="Enter medication"
                                name="medication" 
                                onChange={handleChange} 
                                value={values.medication}
                            />
                            {(touched.medication && errors.medication) && (
                                <div className="text-danger">
                                    {errors.medication}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label htmlFor="medical_conditions">Medical Conditions OR Special Learning Needs (e.g. Dyslexia, ADHD)</label>
                            <textarea 
                                className="form-control" 
                                id="medical_conditions" 
                                placeholder="Enter medical condition" 
                                name="medical_conditions" 
                                onChange={handleChange} 
                                value={values.medical_conditions}
                            ></textarea>
                            {(touched.medical_conditions && errors.medical_conditions) && (
                                <div className="text-danger">
                                    {errors.medical_conditions}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="mx-4 d-flex justify-content-between align-items-center">
            <Button type="button" isLoading={isLoading} onClick={ () => dispatch(setStep(enrollmentStore?.step - 1)) } className="btn btn-default"> Back </Button>
            <Button type="submit" isLoading={isLoading} className="btn btn-primary"> Next </Button>
        </div>
        </Form>
        </>
  );
};

export default EnrollmentStep3;